var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { c } from '@debbie/cortex/dist';
import * as debtRegisterAPI from '@debbie/cortex/dist/api/debt-register';
import { Button, Modal, SearchInput } from '..';
const ErrorModal = (props) => {
    const [selectedRKIError, setSelectedRKIError] = useState(null);
    const [registeringError, setRegisteringError] = useState(false);
    const searchError = (q) => {
        return [
            'Vi kunne ikke identificere din skyldner',
            'Personen oplyses uden fast bopæl',
            'Udenlandsk adresse er ikke fundet',
            'Personen er død',
            'Debitor oplyses uden fast bopæl',
            'Brev kunne ikke leveres',
            'Personen er under 18 år (CPR)',
            'Indberettet 2 gange (DBL)',
            'Skyldner er afgået ved døden (DØD)',
            'Forkert kreditor (FIN)',
            'Oplysningerne var ikke korrekte (FJL)',
            'Fundamentsdato er for gammel (FUN)',
            'Gældssanering-al gæld bortfald (GAL)',
            'Brev til skyldner kan ikke afleveres (PTI)',
            'Sagen genoptaget ved retten (SGO)',
            'Der er strid i sagen (STR)',
            'Tvangsauktion er aflyst (TAF)',
            'Tvangsakkord er fyldestgjort (TFY)',
            'Varen er taget retur (VTT)',
        ]
            .filter((t) => t.toLowerCase().indexOf(q.toLowerCase()) !== -1 || q.length === 0)
            .map((t) => ({
            key: t,
            heading: t,
            returnData: t,
        }));
    };
    const registerError = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setRegisteringError(true);
            if (!props.rkiReferenceId)
                throw 'Intet rkiReferenceId valgt.';
            if (!selectedRKIError)
                throw 'Ingen fejl valgt.';
            if (!props.userId)
                throw 'Kunne ikke finde debitor.';
            if (!props.caseId)
                throw 'Kunne ikke finde sags id.';
            yield debtRegisterAPI.rkiError(props.userId, props.caseId, props.rkiReferenceId, selectedRKIError);
            yield c.cases.getById(props.caseId);
            yield c.customers.getById(props.customer.customerId);
            props.toggleErrorOpenModal();
        }
        catch (error) {
            console.error(error);
            const err = (error === null || error === void 0 ? void 0 : error.message) ? JSON.parse(error.message) : error;
            alert(err.description || err);
        }
        setRegisteringError(false);
    });
    return (React.createElement(Modal, { header: "Registr\u00E9r fejl", onToggle: props.toggleErrorOpenModal, maxWidth: "350px" },
        React.createElement(SearchInput, { onSelect: (result) => {
                setSelectedRKIError(result);
            }, static: selectedRKIError, onRemoveStatic: () => {
                setSelectedRKIError(null);
            }, searchDelay: 0, forceOpen: true, searchAll: searchError, placeholder: "V\u00E6lg fej\u00E5rsag" }),
        React.createElement(Button, { disabled: !selectedRKIError, loading: registeringError, block: true, onClick: registerError }, "Registr\u00E9r fejl")));
};
export default ErrorModal;
//# sourceMappingURL=ErrorModal.js.map